import { useState } from "react";
import { toast } from "sonner";
import { Eye } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useApi, errText } from "@/lib/api";

const describe = (digest, data) => (digest
  ? `How this Monday's digest looks with today's numbers. Spending highlights come from your ${data?.highlights_source === "bank" ? "bank transactions" : "expenses"}.`
  : "Exactly what your recipients get. The PDF link is created when it sends.");

export const BoardPreview = ({ note, digest = false }) => {
  const api = useApi();
  const id = digest ? "digest" : "board";
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try { setData(digest ? await api.get("/reports/digest/preview") : await api.post("/reports/board/preview", { board_note: note })); }
    catch (e) { toast.error(errText(e, "Couldn't build the preview")); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid={`${id}-preview-btn`} onClick={open} disabled={busy}
        className="flex items-center gap-2 rounded-full border border-[#2A2A2A] px-4 py-2 text-sm hover:border-[#9D00FF] hover:text-[#D9A6FF] transition-colors disabled:opacity-40">
        <Eye size={14} /> {busy ? "Building preview…" : digest ? "Preview Monday digest" : "Preview board email"}
      </button>
      <Dialog open={!!data} onOpenChange={(o) => !o && setData(null)}>
        <DialogContent data-testid={`${id}-preview-dialog`} onOpenAutoFocus={(e) => e.preventDefault()} className="max-w-2xl bg-[#121212] border-[#2A2A2A] text-white p-0 overflow-hidden">
          <DialogHeader className="px-6 pt-6">
            <DialogTitle className="font-display">{digest ? "Monday digest preview" : "Board email preview"}</DialogTitle>
            <DialogDescription className="text-[#A3A3A3]">{describe(digest, data)}</DialogDescription>
          </DialogHeader>
          {data && (
            <div className="px-6 pb-6">
              <div className="rounded-t-lg bg-white text-[#111] px-4 py-3 text-xs space-y-1">
                <p><span className="text-black/50">From:</span> {data.from_name}</p>
                <p data-testid={`${id}-preview-to`} className="break-words"><span className="text-black/50">To:</span> {data.to.join(", ")}</p>
                <p data-testid={`${id}-preview-subject`} className="font-semibold text-sm">{data.subject}</p>
              </div>
              <iframe data-testid={`${id}-preview-frame`} title={`${id} email preview`} sandbox="" tabIndex={-1} srcDoc={data.html}
                className="w-full h-[60vh] rounded-b-lg bg-[#F5F5F2]" />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
